<template>
    <div class="card border-0">
        <div class="card-header">
            <span> {{ planTitle(healthplan) }}</span>
        </div>
        <div class="card-body gray-bg">
            <ul class="list-group mb-3">
                <li class="list-group-item border-top-0 border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0">
                    <div class="row">
                        <div class="col-md-6 sb-benefit-list-title">
                            Member ID
                        </div>
                        <div class="col-md-6  sb-benefit-list-value">
                            {{ healthplan.memberid.substring(0, healthplan.memberid.length - 2) }}
                        </div>
                    </div>
                </li>
                <li class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0" v-if="healthplan.member_number">
                    <div class="row  ">
                        <div class="col-md-6 sb-benefit-list-title">
                            Group #
                        </div>
                        <div class="col-md-6  sb-benefit-list-value">
                            {{healthplan.member_number}}
                        </div>
                    </div>
                </li>
                <li class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0" v-if="healthplan.member_name">
                    <div class="row  ">
                        <div class="col-md-6 sb-benefit-list-title">
                            Member Name
                        </div>
                        <div class="col-md-6  sb-benefit-list-value">
                            {{healthplan.member_name}}
                        </div>
                    </div>
                </li>
                <li class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0" v-if="healthplan.effective_date">
                    <div class="row  ">
                        <div class="col-md-6 sb-benefit-list-title">
                            Effective Date
                        </div>
                        <div class="col-md-6  sb-benefit-list-value">
                            {{healthplan.effective_date}}
                        </div>
                    </div>
                </li>
                <li class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0" v-if="healthplan.termination_date">
                    <div class="row  ">
                        <div class="col-md-6 sb-benefit-list-title">
                            Termination Date
                        </div>
                        <div class="col-md-6  sb-benefit-list-value">
                            {{healthplan.termination_date}}
                        </div>
                    </div>
                </li>
                <template v-for="f in getHpSummaryFields(healthplan.hpd_fields,healthplan.plantype)">
                    <li
                        v-if="f.value !== '' && [1,3].includes(f.highlight)"
                        class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0"
                    >
                        <div class="row  ">
                            <div class="col-md-6 sb-benefit-list-title">
                                {{ f.label }}
                            </div>
                            <div class="col-md-6 sb-benefit-list-value ">
                                {{ f.type == 'currency' ? '$' : '' }}{{ f.value == '' ? '&nbsp' : showValues(f.value) }}{{ f.type == 'percent' ? '%' : '' }}
                            </div>
                        </div>
                    </li>
                </template>
                <li class="list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0" v-if="healthplan.dependants_info && healthplan.dependants_info.length>0">
                    <div class="row  ">
                        <div class="col-md-6 sb-benefit-list-title">
                            Dependents
                        </div>
                        <div class="col-md-6  sb-benefit-list-value" v-for="dependant in healthplan.dependants_info">
                            {{dependant}}
                        </div>
                    </div>
                </li>

            </ul>
            <div class="text-center mb-3 btn-hp">
                <a href="#" v-if="!healthplan.hpd_parentid" @click.prevent="openDetailedView(healthplan)" class="btn-primary btn">
                    View Details
                </a>
                <a v-if="healthplan.provider && ssoButtonText(healthplan.provider)" href="#" @click.prevent="ssoBtnClick(healthplan)" class="btn-primary btn">
                    {{ ssoButtonText(healthplan.provider) }}
                </a>
                <a v-if="false && elig.memberdata['sso_flag'].includes('5') && ['UMR', 'UHC'].includes(healthplan.provider) && showbtns" href="#" @click.prevent="openDetailedView(healthplan)" class="btn-primary btn">
                    {{ ssoButtonText(['UMR', 'UHC'].find(value => value !== healthplan.provider)) }}
                </a>
                <a v-else-if="healthplan.payments.length > 0"
                   @click="openPayments(healthplan)"
                   class="btn-primary btn"
                >
                    View All Payments
                </a>
            </div>
        </div>
        <div id="sso" v-html="sso" ref="sso"></div>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "PlanCardMedical",
    props: ['healthplan','elig','showbtns'],
    data() {
        return {
            sso:''
        }
    },
    computed: {
    },
    methods: {
        ssoBtnClick(healthplan){
          if(healthplan.hpd_parentid){
              this.ssoClick();
          }else{
              this.openDetailedView(healthplan)
          }
        },
        planTitle(healthplan){
            return this.$parent.planTitle(healthplan);
        },
        showViewAll(healthplan){
            return this.$parent.showViewAll(healthplan);
        },
        openDetailedView(healthplan){
            this.$parent.openDetailedView(healthplan);
        },
        getHpSummaryFields(fields, type){
            return this.$parent.getHpSummaryFields(fields, type);
        },
        ssoButtonText(provider){
            return this.$parent.ssoButtonText(provider);
        },
        openPayments(healthplan){
            this.$parent.openPayments(healthplan);
        },
        showValues(value){
            switch (value){
                case '$50 co-pay, waived if admitted':
                    return '$50';
                    break;
                case '$200 co-pay, waived if admitted':
                    return '$200';
                    break;
                default:
                    return value;
            }

        },
        ssoClick() {
            document.getElementById("overlay").style.display = "flex";
            axios
                .get('/api/sso/' + this.healthplan.provider.toLowerCase())
                .then(res => {
                    this.sso = res.data.html;
                }).then(() => {
                this.$refs.sso.children[3].target = '_blank';
                this.$refs.sso.children[3].submit();
                document.getElementById("overlay").style.display = "none";
            });
        }

    },
}
</script>

<style scoped>

</style>
